import { Link } from 'react-router-dom';

const WelcomeSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <p className="text-sm text-gray-500 uppercase tracking-wider mb-4">주지스님 인사말</p>
        
        {/* Abbot Photo */}
        <div className="mb-8">
          <div className="w-48 h-48 mx-auto rounded-full overflow-hidden border-4 border-teal-600 shadow-lg">
            <img
              src="https://static.readdy.ai/image/853dbb08f880e8122464f2674851b25b/cf44481037d5c4f0dc0e3b582380e097.jpeg"
              alt="주지스님"
              className="w-full h-full object-cover object-[center_20%]"
            />
          </div>
        </div>

        <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-800 mb-8 leading-tight">
          성덕사에 오신 것을<br />환영합니다
        </h2>
        
        <div className="space-y-6 text-gray-700 leading-relaxed text-lg mb-12">
          <p>
            성덕사를 찾아주신 모든 분들께 부처님의 자비가 함께 하시길 기원합니다.
          </p>

          <p>
            우리는 살아가면서 수많은 번뇌와 고통을 마주하게 됩니다. 
            그러나 부처님께서는 이미 2,500년 전에 이 모든 고통에서 벗어나는 길을 
            밝혀 주셨습니다. 그것은 바로 팔정도를 실천하는 것입니다.
          </p>

          <p>
            성덕사는 부처님의 가르침을 실천하고 전하는 수행 도량입니다. 
            이곳에서 여러분이 일상의 번잡함을 내려놓고, 고요히 자신의 내면을 
            들여다보는 시간을 가지시길 바랍니다.
          </p>

          <p>
            부처님의 가르침은 어렵거나 멀리 있는 것이 아닙니다. 
            바로 지금 이 순간, 여러분의 마음속에 이미 존재합니다. 
            성덕사가 그 마음을 발견하는 여정의 동반자가 되겠습니다.
          </p>

          <p className="font-medium text-gray-800">
            언제나 여러분을 환영하며, 함께 수행하고 성장하는 도량이 되겠습니다.
          </p>
        </div>

        <Link
          to="/about"
          className="inline-flex items-center space-x-2 px-8 py-3 border-2 border-teal-600 text-teal-600 font-medium rounded-full hover:bg-teal-600 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <span>더 알아보기</span>
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
};

export default WelcomeSection;
